customElements.whenDefined('slideshow-component').then(() => {
  const fadeDuration = 700;

  const getSlides = (component) => Array.from(component.querySelectorAll('.coa-image-slideshow__slide'));
  const getDots = (component) => Array.from(component.querySelectorAll('.slider-counter__link'));

  const updateDots = (component, activeIndex) => {
    getDots(component).forEach((dot, index) => {
      dot.classList.toggle('slider-counter__link--active', index === activeIndex);

      if (index === activeIndex) {
        dot.setAttribute('aria-current', 'true');
      } else {
        dot.removeAttribute('aria-current');
      }
    });
  };

  const setActiveSlide = (component, nextIndex) => {
    const slides = getSlides(component);
    if (slides.length < 1) return;

    const previousIndex = component.coaCurrentIndex || 0;
    const activeIndex = (nextIndex + slides.length) % slides.length;

    if (component.coaFadeTimeout) clearTimeout(component.coaFadeTimeout);

    slides.forEach((slide, index) => {
      slide.classList.remove('is-previous');
      slide.classList.toggle('is-active', index === activeIndex);
      slide.setAttribute('aria-hidden', index === activeIndex ? 'false' : 'true');
      slide.setAttribute('tabindex', index === activeIndex ? '0' : '-1');
    });

    if (previousIndex !== activeIndex && slides[previousIndex]) {
      slides[previousIndex].classList.add('is-previous');

      component.coaFadeTimeout = setTimeout(() => {
        slides[previousIndex].classList.remove('is-previous');
      }, fadeDuration);
    }

    component.coaCurrentIndex = activeIndex;
    component.currentPage = activeIndex + 1;
    updateDots(component, activeIndex);
  };

  const stop = (component) => {
    clearInterval(component.coaAutoplay);
    component.slider?.setAttribute('aria-live', 'polite');
  };

  const start = (component) => {
    const slides = getSlides(component);
    const speed = Number(component.slider?.dataset.speed || 5) * 1000;

    stop(component);

    if (component.slider?.dataset.autoplay !== 'true' || slides.length < 2) return;

    component.slider.setAttribute('aria-live', 'off');
    component.coaAutoplay = setInterval(() => {
      setActiveSlide(component, (component.coaCurrentIndex || 0) + 1);
    }, speed);
  };

  const init = (component) => {
    if (component.coaFadeInitialized) return;

    const slides = getSlides(component);
    if (slides.length < 1) return;

    component.coaFadeInitialized = true;
    component.classList.add('is-initialized');
    setActiveSlide(component, 0);

    component.querySelectorAll('button[name="previous"]').forEach((button) => {
      button.addEventListener(
        'click',
        (event) => {
          event.preventDefault();
          event.stopImmediatePropagation();
          setActiveSlide(component, (component.coaCurrentIndex || 0) - 1);
          start(component);
        },
        true
      );
    });

    component.querySelectorAll('button[name="next"]').forEach((button) => {
      button.addEventListener(
        'click',
        (event) => {
          event.preventDefault();
          event.stopImmediatePropagation();
          setActiveSlide(component, (component.coaCurrentIndex || 0) + 1);
          start(component);
        },
        true
      );
    });

    getDots(component).forEach((dot, index) => {
      dot.addEventListener(
        'click',
        (event) => {
          event.preventDefault();
          event.stopImmediatePropagation();
          setActiveSlide(component, index);
          start(component);
        },
        true
      );
    });

    component.querySelectorAll('.slideshow__autoplay').forEach((button) => {
      button.addEventListener(
        'click',
        (event) => {
          event.preventDefault();
          event.stopImmediatePropagation();

          if (component.coaAutoplay) {
            stop(component);
            button.classList.add('slideshow__autoplay--paused');
            button.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
          } else {
            start(component);
            button.classList.remove('slideshow__autoplay--paused');
            button.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
          }
        },
        true
      );
    });

    component.addEventListener('mouseenter', () => stop(component));
    component.addEventListener('mouseleave', () => start(component));
    component.addEventListener('focusin', () => stop(component));
    component.addEventListener('focusout', () => start(component));

    clearInterval(component.autoplay);
    start(component);
  };

  document.querySelectorAll('slideshow-component.coa-image-slideshow').forEach(init);

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('slideshow-component.coa-image-slideshow').forEach(init);
  });
});
